import { Banner } from "components/DesignSystem/Banner/Banner";
import { Button } from "components/DesignSystem/Button/Button";

type LineItemTaxComplianceProps = {
  missingTaxInfoMessage: string | null;
  hasSystemTaxRate: boolean;
  onAddCustomerAddress?: () => void;
};

export const LineItemTaxCompliance = ({
  missingTaxInfoMessage,
  hasSystemTaxRate,
  onAddCustomerAddress,
}: LineItemTaxComplianceProps) => {
  return (
    <>
      {missingTaxInfoMessage && (
        <Banner
          type="warning"
          description={
            <div className="t-flex t-flex-col t-gap-3">
              <span>{missingTaxInfoMessage}</span>
              {onAddCustomerAddress && (
                <div>
                  <Button
                    customType="secondary"
                    size="xsmall"
                    type="button"
                    onClick={onAddCustomerAddress}
                  >
                    Add address
                  </Button>
                </div>
              )}
            </div>
          }
        />
      )}
      {!missingTaxInfoMessage && hasSystemTaxRate && (
        <Banner
          type="primary"
          title="We've calculated the applicable sales tax for you."
          description="The tax rate has been determined using your registration details, customer location and the item being invoiced."
        />
      )}
    </>
  );
};
